/**
 * PartialDataBadge — selo reutilizável de dados parciais (SP3).
 *
 * Exibe Badge na cor `inovareTeal` com Tooltip "dados até DD/MM" quando
 * `is_partial=true`. Retorna `null` quando os dados são completos.
 *
 * Cores apenas via tokens DS/Mantine. Sem fetch interno.
 */
import { Badge, Tooltip } from '@mantine/core'

export interface PartialDataBadgeProps {
  is_partial: boolean
  /** ISO date string (YYYY-MM-DD ou ISO datetime). Usado no tooltip. */
  as_of?: string | null
}

/** Formata ISO date → "DD/MM" em pt-BR, sem depender de locale do SO. */
function formatAsDayMonth(isoDate: string): string {
  // Aceita tanto "2026-06-05" quanto "2026-06-05T12:34:56Z"
  const datePart = isoDate.split('T')[0]
  const parts = datePart.split('-')
  if (parts.length < 3) return isoDate
  const day = parts[2].padStart(2, '0')
  const month = parts[1].padStart(2, '0')
  return `${day}/${month}`
}

export function PartialDataBadge({ is_partial, as_of }: PartialDataBadgeProps) {
  if (!is_partial) return null

  const tooltipLabel =
    as_of ? `dados até ${formatAsDayMonth(as_of)}` : 'dados parciais'

  return (
    <Tooltip label={tooltipLabel} withArrow position="top" arrowSize={5}>
      <Badge
        size="xs"
        variant="light"
        color="inovareTeal"
        style={{ cursor: 'default' }}
      >
        Parcial
      </Badge>
    </Tooltip>
  )
}
